import React from "react";
import { Box, Grid, Typography, Link, Divider } from "@mui/material";
import logo from "../Assets/Images/logo.png";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 8,
        pt: 8,
        pb: 4,
        backgroundColor: "#0c1320",
        color: "#fff",
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: "auto", px: 2 }}>
        <Grid
          container
          spacing={4}
          sx={{
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* BRAND */}
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src={logo}
              alt="Rite Water Restoration"
              sx={{
                height: 55,
                mb: 2,
                mx: { xs: "auto", md: 0 },
                display: "block",
              }}
            />
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Rite Water Restoration specializes in professional water damage
              restoration and emergency response services. We help homeowners
              and businesses recover quickly, safely, and effectively from
              water-related disasters.
            </Typography>
          </Grid>

          {/* SERVICES */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Our Services
            </Typography>
            {[
              "Water Extraction & Structural Drying",
              "Mold Prevention & Remediation",
              "Sewage Cleanup (Black Water)",
              "Content Cleaning & Pack Out",
              "Drywall & Flooring Repair",
              "Emergency Roof Tarping & Leak Response",
            ].map((service) => (
              <Typography
                key={service}
                variant="body2"
                sx={{ opacity: 0.85 }}
              >
                {service}
              </Typography>
            ))}
          </Grid>

          {/* CONTACT */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Contact
            </Typography>

            <Link
              href="tel:+18888352473"
              color="inherit"
              underline="hover"
              sx={{
                display: "block",
                mb: 0.5,
                fontSize: 14,
              }}
            >
              Phone: +1 (888) 835-2473
            </Link>

            <Link
              href="mailto:support@ritehomepros.com"
              color="inherit"
              underline="hover"
              sx={{
                display: "block",
                mb: 0.5,
                fontSize: 14,
              }}
            >
              Email: support@ritehomepros.com
            </Link>

            <Typography variant="body2">
              Serving Bloomington, IN & Nearby Areas
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 1,
                fontWeight: 600,
                color: "#ff6d00",
              }}
            >
              24/7 Emergency Water Restoration
            </Typography>
          </Grid>
        </Grid>

        {/* DIVIDER */}
        <Divider
          sx={{
            my: 3,
            borderColor: "rgba(255,255,255,0.12)",
          }}
        />

        {/* BOTTOM BAR */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            © {new Date().getFullYear()} Rite Water Restoration. All rights reserved.
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "flex-end" },
              width: { xs: "100%", md: "auto" },
            }}
          >
            <Link
              href="/privacy-policy"
              color="inherit"
              underline="hover"
              variant="caption"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              color="inherit"
              underline="hover"
              variant="caption"
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
